// MIL-STD-2525 (the US military symbology standard) symbols for the card rails, as data URLs.
//
// milsymbol rasterises an SVG on every call, so the task organization (two dozen symbols) would pay
// that cost on each render. Each symbol is drawn once here and kept, keyed by code and size.

import ms from 'milsymbol';

const cache = new Map<string, string>();

export function symbolUrl(sidc: string, size = 28): string {
  const key = `${sidc}@${size}`;
  const hit = cache.get(key);
  if (hit) return hit;
  // `monoColor` must stay '' - passing undefined puts milsymbol on the monochrome path and it draws
  // the outline pass only (trap found at checkpoint 1).
  const url = new ms.Symbol(sidc, { size, monoColor: '', outlineWidth: 2, outlineColor: '#0b0f14' })
    .asCanvas()
    .toDataURL();
  cache.set(key, url);
  return url;
}
